import { useConcreteTestSetTrackerContext } from '../../../ConcreteTestSetTrackerContext'
import { CIMSTableProps } from 'components/CIMSTable/types'
import CIMSTable from 'components/CIMSTable'

function RelationTable<T extends object>(
  props: Pick<
    CIMSTableProps<T, never>,
    'records' | 'columns' | 'rowKey' | 'expand' | 'actions'
  >
) {
  const { relations } = useConcreteTestSetTrackerContext()
  return (
    <CIMSTable
      {...props}
      loading={relations.loading}
      pagination={{ size: 'small' }}
      disable={{ showAll: true }}
    />
  )
}

export default RelationTable
